export const initialBankAccount = {
    "accountHolderName": "",
    "accountNumber": "",
    "accountOwnership": "",
    "bankName": "",
    "ifscCode": "",
    "primary": false,
    "status": 1,
    "isCreate": true,
    "ediDocs": []
};

export const initialEDIData = {
    "debitType": "FLAT",
    "debitFrequency": null,
    "settlementFrequency": null,
    "settlementAmountType": "FLAT",
    "totalAmount": "",
    "flatAmount": null,
    "startDate": null,
    "endDate": null,
    "monthlyDebitDate": null,
    "debitAmountPer": null,
    "accountNumber": "",
    "ediEnable": true,
    "settlementType": null,
    "consent": false,
    "isCreate": true
}


export const termsConditions = `
TERMS AND CONDITIONS

Welcome to [Your Company Name]! These terms and conditions outline the rules and regulations for the use of [Your Company Name]'s services, located at [Your Website URL].

By accessing this website, we assume you accept these terms and conditions. Do not continue to use [Your Company Name] if you do not agree to all the terms and conditions stated on this page.

1. DEFINITIONS
   a. "Company", "We", "Our", "Us" refers to [Your Company Name].
   b. "You", "Your" refers to the individual accessing our services.
   c. "Services" refers to the services offered by [Your Company Name].

2. USAGE
   a. The content of this website is for general information and use only. It is subject to change without notice.
   b. Unauthorized use of this website may give rise to a claim for damages and/or be a criminal offense.
   c. You are prohibited from using the website to engage in fraudulent, unlawful, or harmful activities.

3. ACCOUNTS AND SECURITY
   a. To use certain features, you may need to create an account. You are responsible for maintaining the confidentiality of your account information.
   b. You agree to notify us immediately of any unauthorized use of your account or other security breaches.

4. COPYRIGHT AND INTELLECTUAL PROPERTY
   a. Unless otherwise stated, [Your Company Name] owns the intellectual property rights for all material on this website.
   b. You must not republish, sell, or redistribute content from [Your Company Name] without our written consent.

5. LIMITATION OF LIABILITY
   a. We do not guarantee the accuracy, completeness, or timeliness of the information provided.
   b. [Your Company Name] shall not be held liable for any damages arising from the use or inability to use our services.

6. THIRD-PARTY LINKS
   a. This website may include links to other websites. These links are provided for your convenience to provide further information. They do not signify our endorsement of the website(s).
   b. We are not responsible for the content of the linked website(s).

7. MODIFICATION
   a. [Your Company Name] reserves the right to revise these terms at any time without notice.
   b. Your continued use of the website signifies your acceptance of the updated terms.

8. GOVERNING LAW
   a. These terms will be governed by and interpreted in accordance with the laws of [Your Country/State], and you submit to the jurisdiction of the courts located in [Your Country/State] for the resolution of any disputes.

9. TERMINATION
   a. We reserve the right to terminate or suspend your access to our services immediately, without prior notice or liability, for any reason, including if you breach these terms.

10. PRIVACY POLICY
   a. By using our services, you agree to the collection and use of information in accordance with our Privacy Policy.

11. CONTACT US
   a. If you have any questions about these Terms and Conditions, please contact us at [Your Contact Information].

Effective Date: [Insert Date]
`;


export const multipleAdditionalDoc = [
    {
        fieldType: 'file',
        label: 'Add Documents',
        name: 'WEB_CRAWLING',
        props: {
            placeholder: 'Documents',
            type: 'file',
            accept: 'image/*, .pdf, .doc, .docx',
            multiple: false,
            required: true,
        },
    },
]

export const SETTLEMENT_TYPES = {
   ODS: 'ODS'
}

export const ERROR_MESSAGES = {
   MIN_ODS_AMOUNT: 'Please fill min ODS amount',
   NUMBER_OF_ODS: 'Please fill number of ODS in a day',
   COOLING_PERIOD: 'Please fill cooling period',
 };
 
